<mip-modal maxWidth="500px" [size]="isDesktop ? 'md' : 'full'">
  <!-- MODAL -->
  <mip-card class="invitation">
    <mip-card-header class="--flex-row" *ngIf="profile" [class.--flex-row--space-between]="slideIndex === 1" (click)="slidePrev()">
      <!-- HEADER: back -->
      <button mat-button class="__back" *ngIf="slideIndex === 1">
        <mip-icon icon="chevron-left"></mip-icon>
      </button>

      <!-- HEADER: close -->
      <a mat-button class="__close" routerLink="/@{{ profile.username }}">
        <mip-icon icon="times"></mip-icon>
      </a>
    </mip-card-header>

    <!-- MODAL: CONTENT -->
    <mip-card-content class="--no-padding --flex-column --flex-row--space-between" *ngIf="profile">
      <swiper #swiper class="__swiper-container" [config]="config">
        <ng-template class="__item __invitation" swiperSlide>
          <!--  mip-color--bg-dark -->
          <div class="__information">
            <div class="--flex-row">
              <div class="__text">
                <h3 class="__subtitle" mipTranslate="profile.invite.invitation.greeting">Hello!</h3>
                <h2 class="__title" *ngIf="profile.getName()">{{ profile.getName() || '@' + profile.username }}</h2>
                <h2 class="__title" *ngIf="!profile.getName()">
                  <mip-profile-slug-name [user]="profile"></mip-profile-slug-name>
                </h2>

                <h4 class="__description" mipTranslate="profile.invite.invitation.message">is inviting you to join <strong>GotChosen</strong>!</h4>
              </div>

              <div class="__avatar --flex-row --flex-column--center">
                <mip-avatar [size]="90" [userModel]="profile" borderColor="gray"></mip-avatar>
              </div>
            </div>

            <div class="__text __second-line">
              <h4 class="__description" mipTranslate="profile.invite.invitation.description">
                GotChosen is a social monetization platform that shares ad revenue with <strong>all influencers</strong>.
              </h4>
              <h4 class="__description" mipTranslate="profile.invite.invitation.subdescription">
                Not an influencer? It's ok! <br />
                We have several monetization programs <strong>for you too</strong>. Register now, download our App and activate your monetization.
              </h4>
            </div>

            <div class="__button-next --flex-row" mipBgColor="primary" (click)="slideNext()">
              <span mipTranslate="profile.invite.see-details">See details</span>
              <mip-icon icon="chevron-right-small"></mip-icon>
            </div>
          </div>

          <div class="__register-form">
            <h2 class="__title" mipTranslate="profile.invite.form-create-account">Create Account</h2>

            <!-- REGISTER FORM -->
            <mip-register-form [disableHeader]="true" [disableLoginBtn]="true"></mip-register-form>
          </div>
        </ng-template>

        <ng-template class="__item __invitation" swiperSlide>
          <div class="__more-details">
            <div class="__description __first-message">
              <h1 mipTranslate="profile.invitation.how-it-works.title">How it works</h1>
              <h3 mipTranslate="profile.invitation.how-it-works.subtitle1">You:</h3>
              <h4 mipTranslate="profile.invitation.how-it-works.description1">Create content on the GotChosen App and share with your followers everywhere.</h4>
              <h3 mipTranslate="profile.invitation.how-it-works.subtitle2">GotChosen:</h3>
              <h4 mipTranslate="profile.invitation.how-it-works.description2">Will generate ad revenue from your viewers and share up to 60% of the earnings with you.</h4>
            </div>

            <div class="__description mip-color--bg-primary">
              <!--<h1 mipTranslate="profile.invitation.qualifications.title">Qualifications</h1>-->
              <div>
                <p mipTranslate="profile.invitation.qualifications.description">
                  Our mission is to enable you to earn money by doing what you love; creating amazing content for your audience.
                </p>
                <p mipTranslate="profile.invitation.qualifications.description1">Choose to monetize.</p>
              </div>

              <img src="{{ assetsPath }}/images/gc-logo-white.png" width="70%" />

              <!--
              <ul>
                <li>
                  <h4 mipTranslate="profile.invitation.qualifications.description1">Must be 18 years-of-age or older or the legal guardian of a minor user.</h4>
                </li>
                <li>
                  <h4 mipTranslate="profile.invitation.qualifications.description2">Must have at least 10,000 followers on either Facebook, Instagram, Twitter or TikTok.</h4>
                </li>
                <li>
                  <h4 mipTranslate="profile.invitation.qualifications.description3">No cost to participate!</h4>
                </li>
              </ul>
              -->
            </div>

            <!--<div class="__description __faq --flex-row --flex-row--center --flex-column--center">
              <a routerLink="/faq" mipTextColor="primary">
                <span mipTranslate="profile.invitation.more-details.description">More details on our FAQ</span>
              </a>
            </div>-->
          </div>
        </ng-template>
      </swiper>
    </mip-card-content>
  </mip-card>
</mip-modal>
